"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CleveronMiniLogo;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _path, _path2, _defs;
/* eslint-disable max-len */
function CleveronMiniLogo(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_material.SvgIcon, {
    className: className,
    style: {
      width: 'auto'
    },
    viewBox: "0 0 16 16"
  }, _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.68028 3.31064C3.52191 3.35338 3.37215 3.42576 3.23817 3.52432C2.02802 4.08663 1.07559 5.0793 0.521522 6.29322C-0.0637729 7.57556 0.0512627 9.06471 0.539148 10.3872C0.655773 10.7033 0.786845 11.0138 0.932018 11.3174C1.92249 13.4608 3.72084 15.0699 5.89083 15.7545C7.64354 16.2369 9.50488 16.0034 11.1006 15.1009C14.0497 13.8706 16.2092 10.981 15.6691 7.69242C15.4976 9.80581 13.7872 11.2958 11.9251 12.1093L11.5905 12.2727C8.65018 13.6113 5.23354 12.2096 3.9312 9.13034C3.80218 8.87495 3.69038 8.61034 3.59663 8.33846C2.78411 6.40275 3.02308 4.50474 4.5406 3.38605C5.03982 3.01864 5.62861 2.80927 6.23735 2.78271H5.95058C5.16887 2.80594 4.39846 2.98509 3.68028 3.31064Z",
    fill: "url(#paint0_linear_3478_21724)"
  })), _path2 || (_path2 = /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.28679 0.859481C1.25303 2.19655 -0.471781 5.43871 0.113254 8.70452C0.269117 6.61331 1.56312 4.77804 3.47941 3.93036C3.62652 3.85078 3.7803 3.78421 3.93899 3.73144C4.78033 3.38185 5.68667 3.21653 6.59713 3.24656C7.75103 3.25357 8.86651 3.66238 9.75212 4.4028C10.4008 4.8696 10.9498 5.46137 11.3669 6.14339C12.1267 7.14698 12.5874 8.34518 12.696 9.59968C12.7543 10.7191 12.2334 11.7898 11.3172 12.4343C8.83295 14.2247 5.86428 11.6759 5.86428 11.6759C7.58276 13.2623 10.0834 13.664 12.2115 12.6954L12.5469 12.5214C13.4388 12.1571 14.202 11.577 14.7837 10.8537C16.1789 9.11893 15.9897 6.57731 14.8945 4.63903C13.9599 2.70765 12.3254 1.20506 10.3235 0.436768C9.56582 0.148084 8.76176 0.000606802 7.95105 0.00162339C6.65722 -0.0247239 5.377 0.269998 4.22468 0.859481",
    fill: "url(#paint1_linear_3478_21724)"
  })), _defs || (_defs = /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_3478_21724",
    x1: "15.3664",
    x2: "0.0238972",
    y1: "2.76911",
    y2: "2.76911"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#ED1B2F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.53",
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8",
    stopColor: "#981B1E"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#360000"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_3478_21724",
    x1: "0.00146293",
    x2: "15.9876",
    y1: "3135.29",
    y2: "3135.29"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#ED1B2F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.53",
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8",
    stopColor: "#981B1E"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#360000"
  })))));
}